<template>
  <tr class="operation-log-row">
    <td class="operation-log-col" style="width:25%;">
      <a @click="$emit('to-log', log.traceId)">
        <strong class="accent--text">
          {{ log.traceId }}
        </strong>
      </a>
    </td>
    <td class="operation-log-col" style="width:15%;">
      <span>
        {{ log.dateTime | moment('MM/DD/YYYY h:mm A') }}
      </span>
    </td>
    <td class="operation-log-col" style="width:15%;">
      <span>
        {{ log.type }}
      </span>
    </td>
    <td class="operation-log-col" style="width:15%;">
      <span>
        {{ log.operation }}
      </span>
    </td>
    <td class="operation-log-col" colspan="3" style="width: 30%">
      <h4 class="operation-log__name">
        {{ log.profile.firstName }} {{ log.profile.lastName }}
      </h4>
      <p>
        <span class="pr-2">{{ log.profile.email }}</span>
        <span class="bhGray2--text text-nowrap">
          ID: {{ log.profile.id }}
        </span>
      </p>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'OperationsTableRow',
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  methods: {},
}
</script>

<style lang="scss">
.operation-log {
  &__name {
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
      &.wrapped {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 300px;
        white-space: nowrap;
        margin-bottom: 0;
        &::after {
          content: '';
          display: block;
        }
      }
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
    }
    &--full {
      width: 100%;
    }
  }
}
</style>
